import { useEffect } from "react";
import feather from "feather-icons";
import { Route, Routes } from 'react-router-dom';

import Home from './pages/Home';
import Faq from './pages/Faq';
import Navbar from './pages/Navbar';
import Useracc from "./pages/Useraccount";
import Shop from "./pages/Shop/Shop";
import Contact from "./pages/Contact";
import Login from "./pages/Login";
import Wishlist from "./pages/Wishlist";
import Checkout from "./pages/Checkout";
import Placeorder from "./pages/Placeorder";
import Trackorder from "./pages/Trackorder";
import Cart from "./pages/Cart";
import Signup from "./pages/Signup";
import Forgotpass from "./pages/Forgotpass";
import Otp from "./pages/Otp";
import Aboutus from "./pages/Aboutus";
import Blog from "./pages/Blog";
import Blogdetails from "./pages/Blogdetails";
import ComboDetail from "./pages/ComboDetail";
// Remove these individual policy imports
// import Privacypolicy from "./pages/Privacypolicy";
// import Termsandcondition from "./pages/Termsandcondition";
// import Returnpolicy from "./pages/Returnpolicy";
// import Shippingpolicy from "./pages/Shippingpolicy";
import Bulkorder from "./pages/Bulkorder";
import Recipe from "./pages/Recipe";
import Authenticity from "./pages/Authenticity";
import ProteinCerti from "./pages/ProteinCerti";
import Labdoor from "./pages/Labdoor";
import Bulkorder_Form from "./pages/Bulkorder_Form";
import WhyEvercore from "./pages/Whyevercore";
import Collagen_Product from "./pages/Collagen_Product";
import Yeastprotein from "./pages/Yeastprotein_Product";
import Ourstory from "./pages/Ourstory";
import Productdetails from "./pages/Productdetails";
import { Navigate } from "react-router-dom";
import PolicyPage from "./pages/Privacypolicy"; // Import the new PolicyPage component
import OrderDetail from "./pages/OrderDetail";
import PaymentCallback from './pages/PaymentCallback';
import Bestsellers from "./components/Bestsellers";
import PaymentSuccessPage from "./pages/PaymentSuccessPage";

function App() {
     useEffect(() => {
    feather.replace();
  }, []);
  return (
    < >
         <Routes >
          <Route path="/payment-success" element={<PaymentSuccessPage />} />
          <Route path="/bestsellers" element={<Bestsellers />} />

           <Route path='/' element={<Home/>}/>
           <Route path='/faq' element={<Faq/>}/>
           <Route path='/Navbar' element={<Navbar/>}/>
           <Route path="/Contact" element={<Contact/>}/>
           <Route path='/Shop' element={<Shop/>}/>
           <Route path="/product/:id" element={<Productdetails />} />
           <Route path='/UserAccount' element={<Useracc/>}/>
           <Route path='/authenticity' element={<Authenticity/>}/>
           <Route path="/Login" element={<Login/>}/>
           <Route path="/Wishlist" element={<Wishlist/>}/>
           <Route path="/Checkout" element={<Checkout/>}/>
      
           <Route path="/placeorder/:orderId?" element={<Placeorder />} />
           <Route path="/payment-callback" element={<PaymentCallback />} />
           <Route path="/track-order/:orderId" element={<Trackorder />} />
           <Route path="/orders/:orderId" element={<OrderDetail />} />
           <Route path="/Cart" element={<Cart/>} />
           <Route path="/Signup" element={<Signup/>}/>
           <Route path="/Forgotpass" element={<Forgotpass/>}/>
           <Route path="/Otp" element={<Otp/>}/>
           <Route path='/UserAccount' element={<Useracc/>}/>
           <Route path="/Aboutus" element={<Aboutus/>}/>
           <Route path="/Blog" element={<Blog/>}/>

           <Route path="/Blogdetails/:id" element={<Blogdetails />} />
           <Route path="/combo/:comboId" element={<ComboDetail />} />
           
           {/* Dynamic policy route */}
           <Route path="/policies/:policyType" element={<PolicyPage/>} />
           
           {/* Keep these for backward compatibility (redirect to dynamic route) */}
           <Route path="/PrivacyPolicy" element={<Navigate to="/policies/privacy" replace />} />
           <Route path="/Termsandcondition" element={<Navigate to="/policies/terms" replace />} />
           <Route path="/Returnpolicy" element={<Navigate to="/policies/return" replace />} />
           
           {/* ✅ ADDED: Exchange Policy Route */}
           <Route path="/Exchangepolicy" element={<Navigate to="/policies/exchange" replace />} />
           
           {/* ✅ ADDED: Shipping Policy Route */}
           <Route path="/Shippingpolicy" element={<Navigate to="/policies/shipping" replace />} />
           
           <Route path="/bulk-orders" element={<Bulkorder/>}/>
           <Route path="/recipe" element={<Recipe/>}/>
           <Route path="/why-evercore" element={<WhyEvercore/>}/>
           <Route path="/ProteinCerti" element={<ProteinCerti/>}/>
           <Route path="/Labdoor" element={<Labdoor/>}/>
           <Route path="/Collagen" element={<Collagen_Product/>}/>
           <Route path="/Yeastprotein" element={<Yeastprotein/>}/>
           <Route path="/Ourstory" element={<Ourstory />}/>
           <Route path="/Bulkorder_Form" element={<Bulkorder_Form/>}/>
         </Routes>
          <div className="theme-option">
            <div className="back-to-top">
                <a id="back-to-top" href="#">
                    <i className="fas fa-chevron-up"></i>
                </a>
            </div>
        </div>
    </>
  );
}

export default App;